import { useEffect, useState } from "react";
import RankTableFaculty from "Benchmarking/Components/RankTableFaculty";
import RankTableInstitution from "Benchmarking/Components/RankTableInstitution";
import "Benchmarking/Scss/Home.scss";
const Home = () => {
  const [entity, setEntity] = useState("faculty");
  const [data, setData] = useState([]);

  useEffect(() => {
    // if (entity == "faculty") {
    //   getAuthorRanking([], (res) => {
    //     setData(add_color_ratio_data(res));
    //   });
    // } else {
    //   getInstitutionRanking([], (res) => {
    //     setData(add_color_ratio_data(res));
    //   });
    // }
  }, [entity]);
  return (
    <div className="home-benchmarking">
      <div className="table">
        {entity == "faculty" && <RankTableFaculty data={data} />}
        {entity == "institution" && <RankTableInstitution data={data} />}
      </div>
    </div>
  );
};

export default Home;
